import { Subscription } from 'rxjs'

export async function subscribeToRequest<Response>(
  handlers: { promise: Promise<Response>; subscription: Subscription | null },
  existing: Subscription | null,
  setSubscription: (subscription: Subscription | null) => void
) {
  existing?.unsubscribe()
  setSubscription(handlers.subscription)
  return await handlers.promise.finally(() => setSubscription(null))
}
